import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ErrorPopupData {
  title: string;
  message: string;
  type?: 'error' | 'warning' | 'info' | 'success';
}

@Injectable({
  providedIn: 'root'
})
export class ErrorPopupService {
  private popupSubject = new Subject<ErrorPopupData>();
  popupState$ = this.popupSubject.asObservable();

  open(data: ErrorPopupData) {
    this.popupSubject.next(data);
  }

  /**
   * DKM-4567 Cedric: uygulamada popup'ı gösterecek bir `<dk-error-popup>` takılı mı?
   * (Yalnız dabnet-kamu app.component'te var; e-belediye/mobile-kamu'da yok — orada popup açılsa görünmez.)
   */
  get hasHost(): boolean {
    return this.popupSubject.observed;
  }
}
